// import useOpenpayCards from "@/composables/useOpenpayCards";
// import useUserCredit from "@/composables/useUserCredit";
import objectValidation from '@/helpers/objectValidation'
import { useGlobalErrorsStore } from '@/stores/globalErrors'
// import {  useQuery } from "@tanstack/vue-query";
import { useDebounceFn } from '@vueuse/core'
// import { set } from "lodash";
import moment from 'moment'
// import { NULL } from "sass";
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useToast } from 'vue-toastification'

// import { Credit } from '@/interfaces/credit';
import useAuthUser from '@/composables/useAuthUser'
import useTripReasonOptions from '@/composables/useTripReasonOptions'

import {
	TRIP_REASON_NONE,
	TRIP_REASON_OTHER,
	tripReasonIdFromKey,
	tripReasons,
} from '@/enums/tripReasons'

// import { HotelPnrRequest } from "../interfaces/hotelPnrRequest";

import type { BillingInformation } from '@/interfaces/billingInformations'
import type { OpenPayCard } from '@/interfaces/openPayCard'

import useCompany from '@/modules/companies/composables/useCompany'
import useCompanyCredit from '@/modules/companies/composables/useCompanyCredit'
import useCompanyOpenPayCard from '@/modules/companies/composables/useCompanyOpenPayCard'
// import type { Card } from "@/interfaces/card";
// import axios from "@/lib/axios";
import useConfirmations from '@/modules/confirmations/composables/useConfirmations'
import useUserBillingInformation from '@/modules/users/composables/useUserBillingInformation'
import useUserGuaranteeCards from '@/modules/users/composables/useUserGuaranteeCards'
import useUserOpenPayCard from '@/modules/users/composables/useUserOpenPayCard'
// import useUser from "@/modules/users/composables/useUser";
import useUsers from '@/modules/users/composables/useUsers'
import type { User } from '@/modules/users/interfaces/user'

import useHotelBook from '../composables/useHotelBook'
import { RateForm } from '../interfaces/rateForm'
import { InputTypes } from '../interfaces/rateInputTypes'
import useHotelGroupPolicies from './useHotelGroupPolicies'

// import useCredit from '@/composables/useCredit';

const useHotelRate = () => {
	const { setError } = useGlobalErrorsStore()
	const route = useRoute()
	const form = reactive<RateForm>({
		travelers: [],
		cardDetails: [],
		authorizedCharges: [],
		authorizedGroups: [],
	})

	const showModal = ref(false)

	const actionShowModal = () => {
		showModal.value = !showModal.value
	}

	const {
		hotelRate,
		isFetching,
		creatingBooking,
		policyInformation,
		policyErrorFlag,
		createBooking,
		fillPayloadValues,
		setPayloadValue,
		// returnToDetails
		isLoading,
	} = useHotelBook()

	onMounted(async () => {
		const response = await refetch()
		await refetchCompany()
		await companyOpenPayCardsRefetch()
		await refetchCredit()
		await refetchPolicies()

		const travelers = [...users.value] as Array<User>

		if (response.isFetched) {
			travelers.forEach((user, index) => {
				form.travelers[index] = {
					mainGuest: {
						id: user.id,
						name: `${user.name}`,
						lastname: `${user.lastname}`,
					},
					email:
						validationHandlers.empty(user.email) ?
							selectDefaults.email
						:	user.email,
					additionalGuests: [],
					costCenter: user.costCenterId ?? null,
					loyaltyProgram: null,
				}

				for (let guest = 0; guest < guests.value - 1; guest++) {
					form.travelers.at(index)?.additionalGuests?.push({
						name: '',
						lastname: '',
						id: 0,
					})
				}
			})
		}

		adicionalCharges.forEach((charge, index) => {
			form.authorizedCharges[index] = {
				id: index + 1,
				name: charge,
				active: charge === 'Habitación' ? true : false,
			}
		})

		chargesGroups.forEach((charge, index) => {
			form.authorizedGroups[index] = {
				id: index + 1,
				name: charge,
				date: undefined,
				time: undefined,
				mountingDetails: '',
				noPax: 0,
				active: false,
			}
		})
	})

	const toast = useToast()
	moment.localeData('es-mx')

	const router = useRouter()
	const { user, isInternal } = useAuthUser()
	const memberId = Number(route.query.memberId as string) || user.value?.id || 0

	if (!memberId) {
		throw new Error('No se encontró el id del socio de la empresa')
	}

	const { isEmpty: isEmptyObject } = objectValidation()

	const imgUrl = route.query.img
	const invalidImage = ref(false)

	const selectDefaults = {
		costCenter: 'Seleccionar centro de costos',
		email: 'Seleccionar email',
	}

	const requireInvoice = ref(false)
	const mandatoryCostCenterRequirement = ref<boolean | null>(null)
	const setMandatoryCostCenterRequirement = (value: boolean) => {
		mandatoryCostCenterRequirement.value = value
	}
	const adicionalCharges = [
		'Habitación',
		'Restaurante',
		'Bar/Lobby bar',
		'Lavandería',
		'Room Service',
		'Bebidas no alcohólicas',
		'Internet',
	]
	const chargesGroups = ['Renta de salon', 'Coffee break', 'Audiovisual']
	const intToOrdinal = {
		1: '1er',
		2: '2do',
		3: '3ero',
		4: '4to',
	}

	const guests = ref(parseInt(route.query.GuestCount as string))
	const travelers = ref(parseInt(route.query.Quantity as string))
	const travelersIds: Array<string | number> = JSON.parse(
		route.query.users as string
	)

	const travelerCompanyId = computed(() => {
		return users.value[0]?.companyId
	})
	const travelerCompanyGroupId = computed(() => {
		return users.value[0]?.companyGroupId
	})
	const travelerEmail = computed(() => users.value[0]?.email ?? '')

	const { users, refetch } = useUsers({
		ids: travelersIds,
	})

	const { userGuaranteeCards } = useUserGuaranteeCards({
		params: { userId: memberId },
		immediate: true,
	})

	const cardUserId = computed(() => {
		const firstTraveler = users.value[0]
		if (!firstTraveler) return memberId
		return firstTraveler.internal ? memberId : Number(travelersIds[0])
	})

	const { data: travelerBillingData } = useUserBillingInformation({
		params: { id: travelersIds[0] },
		immediate: true,
	})

	const travelerHasBillingInfo = computed(() => !!travelerBillingData.value)

	const { queryCards: userOpenPayCards, isError: isErrorUserCards } =
		useUserOpenPayCard({ params: { user_id: memberId }, immediate: true })

	const travelerId = computed(() => Number(travelersIds[0]))
	const isTravelerDifferentFromMember = computed(
		() => travelerId.value !== memberId
	)

	const { queryCards: travelerOpenPayCards, isError: isErrorTravelerCards } =
		useUserOpenPayCard({
			params: { user_id: travelerId },
			immediate: isTravelerDifferentFromMember,
		})
	const { company, refetch: refetchCompany } = useCompany(
		{ companyId: travelerCompanyId! },
		{ immediate: false }
	)
	const {
		cards: companyOpenPayCards,
		isError: isErrorCompanyCards,
		refetch: companyOpenPayCardsRefetch,
	} = useCompanyOpenPayCard({
		params: { companyId: travelerCompanyId! },
		immediate: false,
	})
	const { credit, refetch: refetchCredit } = useCompanyCredit({
		params: { companyId: travelerCompanyId! },
		immediate: false,
	})
	// const { data: companyGroup, refetch: CompanyGroupRefetch } = useGroup({
	//   params: { groupId: travelerCompanyGroupId!}, immediate: false
	// });

	watch(user, async () => {
		// await refetch()
		await refetchPolicies()
	})

	const {
		policyObjectMapWithCountryNames,
		policyObjectMap,
		availablePolicies,
		loadingPolicies,
		refetchPolicies,
	} = useHotelGroupPolicies({
		companyGroupId: travelerCompanyGroupId,
		immediate: false,
	})

	// Night rates code
	// const taxesIncludedInNights = computed(() =>
	//   hotelRate.value
	//     ? hotelRate.value.rates[0].amountAfterTax != 0
	//       ? true
	//       : false
	//     : false,
	// );

	// const nightRates = computed(() => {

	// });

	// Authorized charges code
	const allSelected = ref(false)

	const selectAllAuthorizedCharges = () => {
		if (!allSelected.value) {
			form.authorizedCharges.forEach((charge) => {
				charge.active = true
			})
		} else {
			form.authorizedCharges.forEach((charge) => {
				charge.active = false
			})
		}

		form.authorizedCharges[0].active = true
	}

	const attemptedToSubmit = ref(false)

	const activeAuthorized = computed(() => {
		const charges = form.authorizedCharges.filter(
			(charge) => charge.name !== 'Habitación' && charge.active
		)
		const groups = form.authorizedGroups.filter((group) => group.active)

		const warnings = []

		let warningStatus = false

		if (charges.length > 0 && !expandedRefs.authorizedCharges) {
			warnings.push('Hay cargos autorizados seleccionados')
			warningStatus = true
		}

		if (groups.length > 0 && !expandedRefs.authorizedGroups) {
			warnings.push('Hay grupos autorizados seleccionados')
			warningStatus = true
		}

		return {
			charges,
			groups,
			warnings,
			warningStatus,
		}
	})

	const expandedRefs = reactive({
		authorizedCharges: false,
		authorizedGroups: false,
	})

	// Input validation code
	const inputTypes: InputTypes = {
		default: 'default',
		name: 'name',
		lastname: 'lastname',
		email: 'email',
		group: 'group',
		paymentMethod: 'paymentMethod',
		cards: 'cards',
		costCenter: 'costCenter',
		companyBilling: 'companyBilling',
	}

	const validationErrors = {
		default: 'Este campo es requerido.',
		invalidCharacters: 'Este campo contiene caracteres inválidos.',
		names: {
			minLength: 'El nombre debe de tener menos 2 caracteres.',
			maxLength: 'El nombre debe tener menos de 80 caracteres.',
		},
		lastnames: {
			minLength: 'El apellido debe tener al menos 2 caracteres.',
			maxLength: 'El apellido debe tener menos de 80 caracteres.',
		},
		email: {
			required: 'El email es requerido.',
		},
		paymentMethod: {
			required: 'El método de pago es requerido.',
			cards: {
				required: 'Debe seleccionar una tarjeta.',
			},
		},
		costCenter: {
			required: 'El centro de costos es requerido.',
		},
		companyBilling: {
			required: 'Es necesario seleccionar una razón fiscal.',
		},
	}

	const validateString = (string: string) => {
		const result = string

		return result
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.trim()
	}

	type value = string | number | boolean

	const validationHandlers = {
		empty: (value: value) => {
			return value === '' || !value
		},
		minLength: (value: string, min: number) => {
			return value.length <= min
		},
		maxLength: (value: string, max: number) => {
			return value.length >= max
		},
		equalTo: (value: value, equal: value) => {
			return value === equal
		},
		hasInvalidCharacters: (value: string) => {
			const regex = new RegExp(/[^a-zA-Z\s]/g)

			return value === '' ? false : regex.test(value)
		},
		isOdd: (value: number) => {
			return value % 2 !== 0
		},
	}

	const validationGroups = {
		name: (name: string) => {
			return (
				validationHandlers.minLength(name, 2) ||
				validationHandlers.maxLength(name, 80)
			)
		},
		lastname: (lastname: string) => {
			return (
				validationHandlers.minLength(lastname, 2) ||
				validationHandlers.maxLength(lastname, 80)
			)
		},
		email: (email: string) => {
			return validationHandlers.equalTo(email, 'Seleccionar email')
		},
	}

	const validate = (
		value: any,
		field: string,
		checkInvalidCharacters = false
	) => {
		let error

		const { empty, minLength, maxLength, equalTo } = validationHandlers

		if (
			validationHandlers.hasInvalidCharacters(value) &&
			checkInvalidCharacters
		) {
			// Error occurred

			return (error = validationErrors.invalidCharacters)
		}

		switch (field) {
			case 'name':
				if (minLength(value, 2)) {
					error = validationErrors.names.minLength
				} else if (maxLength(value, 80)) {
					error = validationErrors.names.maxLength
				}
				break
			case 'lastname':
				if (minLength(value, 2)) {
					error = validationErrors.lastnames.minLength
				} else if (maxLength(value, 80)) {
					error = validationErrors.lastnames.maxLength
				}
				break
			case 'email':
				if (equalTo(value, 'Seleccionar email')) {
					error = validationErrors.email.required
				}
				break
			case 'group':
				if (empty(value)) {
					error = validationErrors.default
				}
				break
			case 'paymentMethod':
				if (empty(value)) {
					error = validationErrors.paymentMethod.required
				}
				break
			case 'cards':
				if (empty(value)) {
					error = validationErrors.paymentMethod.cards.required
				}
				break
			case 'costCenter':
				if (empty(value)) {
					error = validationErrors.costCenter.required
				}
				break
			case 'companyBilling':
				if (equalTo(value, 0)) {
					error = validationErrors.companyBilling.required
				}
				break
			default:
				if (empty(value)) {
					error = 'Este campo es requerido.'
				}
				break
		}

		if (error != '') return error
	}

	const paymentMethod = ref('')
	const selectedPaymentMethod = ref('')
	const cardType = ref<string | undefined>('')

	const selectedCardId = ref('') // paymentMethodId

	const paymentTypes = {
		credit: 'credit',
		companyCard: 'companyCard',
		userCards: 'userCards',
		travelerCards: 'travelerCards',
		addAndPay: 'addAndPay',
		errorOpenPay: 'errorOpenPay',
		destination: 'destination',
	}

	const paymentOptions = computed(() => {
		const result = []

		const card = Boolean(
			company.value?.paymentMethods?.options?.includes('card')
		)

		const credit = Boolean(
			company.value?.paymentMethods?.options?.includes('credit')
		)

		// Opción «tarjeta de garantía / pago en destino» SOLO para tarifas de
		// pago-en-destino (Amadeus internacional). Hotelbeds es PREPAGO
		// (paymentModel = 'prepaid') → se cobra por crédito/OpenPay, sin garantía.
		if (
			hotelRate.value?.addresses[0]?.countryCode !== 'MX' &&
			hotelRate.value?.isInternational &&
			hotelRate.value?.paymentModel !== 'prepaid' &&
			userGuaranteeCards.value?.length! > 0
		) {
			result.push({
				name: 'Tarjetas',
				value: paymentTypes.destination,
				icon: 'credit_card',
			})
		}

		if (card) {
			if (companyCards.value.length) {
				result.push({
					name: 'Tarjeta de su empresa',
					value: paymentTypes.companyCard,
					icon: 'store',
				})
			}
		}

		const hasUserCards = !isErrorUserCards.value && userCards.value.length! > 0
		const canCreateUserCards = Boolean(travelerEmail.value)

		if (hasUserCards || canCreateUserCards) {
			result.push({
				name: 'Mis tarjetas',
				value: paymentTypes.userCards,
				icon: 'credit_card',
			})
		}

		const hasTravelerCards =
			!isErrorTravelerCards.value && travelerCards.value.length > 0
		const canAddTravelerCards =
			isTravelerDifferentFromMember.value && Boolean(travelerEmail.value)

		if (
			isTravelerDifferentFromMember.value &&
			(hasTravelerCards || canAddTravelerCards)
		) {
			result.push({
				name: 'Tarjetas del viajero',
				value: paymentTypes.travelerCards,
				icon: 'person_pin',
			})
		}

		if (credit) {
			result.push({
				name: 'Crédito empresarial',
				value: paymentTypes.credit,
				icon: 'monetization_on',
			})
		}

		if (!isErrorCompanyCards.value || !isErrorUserCards) {
			if (travelerEmail.value) {
				result.push({
					name: 'Agregar tarjeta',
					value: paymentTypes.addAndPay,
					icon: 'add_box',
				})
			}
		} else {
			result.push({
				name: 'Los cargos con tarjeta no esta disponible de momento.',
				value: paymentTypes.errorOpenPay,
				icon: 'warning',
			})
		}

		result.sort((a) => {
			return a.value === paymentTypes.credit ? -1 : 1
		})

		return result
	})

	type billingInformation = BillingInformation & {
		name?: string
		origin: string
		active: boolean
	}

	const selectedBillingInformation = ref<billingInformation>()
	const companyBillingId = ref(0)

	const invoiceOptions = computed(() => {
		const result = {
			company: [] as billingInformation[],
			user: {} as billingInformation,
		}

		// [company.value?.billingInformation]?.forEach((item: any) => {
		//   result.company.push({
		//     origin: "company",
		//     active: true,
		//     ...item,
		//     name: "Empresa",
		//   });
		// });

		// if (user.value?.billingInformation) {
		//   result.user = {
		//     origin: "user",
		//     active: true,
		//     ...user.value.billingInformation,
		//     name: "Usuario",
		//   };
		// }

		return result
	})

	const actualBillingInvalid = computed(() => {
		if (selectedPaymentMethod.value === paymentTypes.companyCard) {
			return !('length' in invoiceOptions.value.company)
		} else {
			return !invoiceOptions.value.user.active
		}
	})

	// Remove after receiving data from backend
	const userCards = computed(() => {
		return (userOpenPayCards.value ?? []).map((card: OpenPayCard) => ({
			id: card.openpayId,
			name: card.cardNumber,
			alias: card.alias,
			institution: card.brand,
			holder_name: card.holderName,
			ownership: card.ownership,
		}))
	})

	// Remove after receiving data from backend
	const companyCards = computed(() => {
		return companyOpenPayCards.value!.map((card: OpenPayCard) => {
			return {
				id: card.openpayId,
				name: card.cardNumber,
				alias: card.alias,
				institution: card.brand,
				holder_name: card.holderName,
				ownership: card.ownership,
			}
		})
	})

	const travelerCards = computed(() => {
		return (travelerOpenPayCards.value ?? []).map((card: OpenPayCard) => ({
			id: card.openpayId,
			name: card.cardNumber,
			alias: card.alias,
			institution: card.brand,
			holder_name: card.holderName,
			ownership: card.ownership,
		}))
	})

	// const selectedCard = computed(() => {
	//   let card = userCards.value.find((card) => card.id === selectedCardId.value);

	//   if (!card && selectedCardId.value) {
	//     card = companyCards.value.length
	//       ? companyCards.value.at(+selectedCardId.value)
	//       : undefined;
	//   }

	//   return card;
	// });

	watch(selectedPaymentMethod, (value) => {
		selectedBillingInformation.value = undefined
		requireInvoice.value = false
		companyBillingId.value = 0

		if (
			value !== paymentTypes.userCards &&
			value !== paymentTypes.travelerCards &&
			value !== paymentTypes.destination
		) {
			selectedCardId.value = ''
		}

		if (value === paymentTypes.companyCard) {
			paymentMethod.value = 'card'
			cardType.value = 'company'
			selectedCardId.value = companyCards.value.at(0)?.id!

			if (!('length' in invoiceOptions.value.company)) {
				selectedBillingInformation.value = invoiceOptions.value.company
			}
		} else if (value === paymentTypes.userCards) {
			paymentMethod.value = 'card'
			cardType.value = 'user'
			selectedCardId.value = userCards.value.at(0)?.id!
		} else if (value === paymentTypes.travelerCards) {
			paymentMethod.value = 'card'
			cardType.value = 'user'
			selectedCardId.value = travelerCards.value.at(0)?.id ?? ''
			selectedBillingInformation.value = invoiceOptions.value.user
		} else if (value === paymentTypes.destination) {
			const defaultCard = userGuaranteeCards.value?.find(
				(card) => card.isDefault
			)
			if (defaultCard) {
				selectedCardId.value = defaultCard.id
			}
		}

		if (value === paymentTypes.credit) {
			paymentMethod.value = 'credit'
			cardType.value = undefined
			requireInvoice.value = false
		}

		if (
			value === paymentTypes.addAndPay ||
			value === paymentTypes.userCards ||
			value === paymentTypes.travelerCards
		) {
			selectedBillingInformation.value = invoiceOptions.value.user
		}
	})

	const disclaimerModalMessage = ref('')

	const invoiceDisclaimer = reactive({
		isOpen: false,
		message:
			'No cuenta con una constancia fiscal registrada, por lo que no podrá solicitar factura.',
	})

	const disclaimerHandlers = {
		invoice: {
			open: () => {
				invoiceDisclaimer.isOpen = true
				disclaimerModalMessage.value = invoiceDisclaimer.message
			},
			close: () => (invoiceDisclaimer.isOpen = false),
		},
	}

	watch(companyBillingId, (value) => {
		if (value != 0) {
			selectedBillingInformation.value = invoiceOptions.value.company.find(
				(item) => item.id === value
			)
		}
	})

	watch(requireInvoice, (value) => {
		if (!value) {
			if (
				selectedPaymentMethod.value === paymentTypes.companyCard &&
				invoiceOptions.value.company.length > 0
			) {
				selectedBillingInformation.value = undefined
				companyBillingId.value = 0
			}
		}
	})

	// Validate data code
	const validateTravelers = () => {
		let travelers = true

		form.travelers.forEach((traveler) => {
			traveler.additionalGuests?.forEach((instance) => {
				if (
					validationHandlers.hasInvalidCharacters(instance.name) ||
					validationGroups.name(instance.name) ||
					validationGroups.lastname(instance.lastname)
				) {
					travelers = false
				}
			})
		})

		return travelers
	}

	const validateAuthorizedGroups = () => {
		let valid = true

		form.authorizedGroups.forEach((group) => {
			if (group.active) {
				valid = !(group.date === undefined || group.time === undefined)
			}
		})

		return valid
	}

	const validatePaymentMethod = () => {
		let valid = true

		if (selectedPaymentMethod.value === '') {
			valid = false
		} else {
			switch (selectedPaymentMethod.value) {
				case paymentTypes.userCards:
				case paymentTypes.travelerCards:
					if (selectedCardId.value === '') {
						valid = false
					}
					break

				default:
					break
			}
		}

		return valid
	}

	const validateCostCenter = () => {
		const isRequired =
			mandatoryCostCenterRequirement.value ??
			Boolean(company.value?.mandatoryCostCenter)
		if (!isRequired) return true

		return form.travelers.every(
			(room) => Number.isInteger(room.costCenter) && Number(room.costCenter) > 0
		)
	}

	const validateBillingInformation = () => {
		let valid = true

		if (requireInvoice.value) {
			if (isEmptyObject(selectedBillingInformation.value || {})) {
				valid = false
			}
		}

		return valid
	}

	const termsAndConditions = reactive({
		value: false,
		attemptedToSubmit: false,
	})

	const tripReason = ref<string>('')
	const otherTripReason = ref<string>('')

	// Catálogo de la empresa del viajero: qué motivos se ofrecen, si es
	// obligatorio y si se permite «Otro». Lo valida también BookingV2.
	const tripReasonCatalog = useTripReasonOptions(travelerId)

	const isOtherTripReason = computed(
		() =>
			tripReason.value === TRIP_REASON_OTHER ||
			tripReason.value === tripReasons.Otro
	)

	const finalTripReason = computed(() =>
		isOtherTripReason.value ? otherTripReason.value.trim() : tripReason.value
	)

	const formIsFilled = computed(() => {
		return (
			(validateAuthorizedGroups() &&
				validateTravelers() &&
				validatePaymentMethod() &&
				validateCostCenter() &&
				validateBillingInformation() &&
				termsAndConditions.value) ||
			termsAndConditions.attemptedToSubmit
		)
	})

	const handleSubmit = useDebounceFn(async () => {
		if (selectedPaymentMethod.value === 'addAndPay') {
			toast.warning('Seleccione un método de pago valido')
			actionShowModal()
			return
		}

		if (paymentMethod.value === 'errorOpenPay') {
			toast.error('Los cargos con tarjeta no están disponibles de momento.')
			return
		}

		if (policyInformation.value?.errors?.length) {
			toast.error(
				'Esta solicitud no cumple con las condiciones de algunas politícas que impiden continuar con la reservación.'
			)
			return
		}

		if (!termsAndConditions.value) {
			termsAndConditions.attemptedToSubmit = true

			toast.warning('Debe aceptar los términos y condiciones para continuar.')
			return
		}

		if (validatePaymentMethod() === false) {
			toast.error('Debe seleccionar un método de pago.')
			return
		}

		attemptedToSubmit.value = true

		if (!tripReason.value) {
			toast.warning('Selecciona un motivo de viaje para continuar.')
			document
				.getElementById('trip-reason')
				?.scrollIntoView({ behavior: 'smooth', block: 'center' })
			return
		}

		if (isOtherTripReason.value && !finalTripReason.value) {
			toast.warning('Escribe cuál es tu motivo de viaje.')
			document.getElementById('other-trip-reason')?.focus()
			return
		}

		if (!validateCostCenter()) {
			toast.warning(
				form.travelers.length > 1 ?
					'Selecciona un centro de costos para cada viajero antes de reservar.'
				:	'Selecciona un centro de costos antes de reservar.'
			)

			requestAnimationFrame(() => {
				const select = document.querySelector<HTMLSelectElement>(
					'[data-cost-center-missing="true"]'
				)
				select?.scrollIntoView({ behavior: 'smooth', block: 'center' })
				select?.focus({ preventScroll: true })
			})
			return
		}

		if (formIsFilled.value && hotelRate.value) {
			fillPayloadValues({
				chainCode: hotelRate.value.chainCode,
				cityCode: hotelRate.value.hotelCityCode,
				hotelCode: hotelRate.value.hotelCode,
				paymentType: hotelRate.value.paymentType,
				bookingCode: hotelRate.value.bookingCode,
				requireInvoice: requireInvoice.value,
				costCenter: form.travelers[0]?.costCenter ?? undefined,
				ratePlanCode: route.query.RatePlanCode as string,
				roomTypeCode: route.query.RoomTypeCode as string,
				billingInformation: selectedBillingInformation.value?.id,
			})

			localStorage.setItem('hotelChainCode', hotelRate.value.chainCode)

			const roomData = Array<any>()

			form.travelers.map((room) => {
				roomData.push([
					{
						id: room.mainGuest.id,
						name: validateString(room.mainGuest.name),
						surname: validateString(room.mainGuest.lastname),
						type: 'ADT',
						principal: true,
						costCenterId: room.costCenter,
						membershipId: room.loyaltyProgram,
					},
					...(room.additionalGuests?.map((instance) => {
						return {
							name: validateString(instance.name),
							surname: validateString(instance.lastname),
							type: 'ADT',
							principal: false,
						}
					}) || []),
				])
			})

			if (paymentMethod.value == 'card') {
				setPayloadValue('cardType', cardType.value)
				setPayloadValue('paymentMethodId', selectedCardId.value)
				setPayloadValue(
					'userId',
					user.value?.internal ? String(route.query.memberId) : null
				)
			}
			setPayloadValue('passengerReference', [...roomData])
			// Las tres llaves van siempre: el payload sobrevive entre intentos, y una
			// que se quedara del intento anterior le gana a la nueva en BookingV2
			// (tripReasonId → reasonOther → reason). Sin catálogo (el endpoint falló)
			// el texto viaja en `reason` y BookingV2 lo empareja o lo trata como «Otro».
			const tripReasonId = tripReasonIdFromKey(tripReason.value)
			const isOther = tripReasonId === null && isOtherTripReason.value
			// `undefined` y no `null`: pisa el valor anterior y el JSON omite la llave.
			setPayloadValue('tripReasonId', tripReasonId ?? undefined)
			setPayloadValue(
				'reasonOther',
				isOther ? finalTripReason.value : undefined
			)
			setPayloadValue(
				'reason',
				tripReasonId === null && tripReason.value !== TRIP_REASON_NONE ?
					finalTripReason.value
				:	undefined
			)
			setPayloadValue(
				'paymentMethod',
				paymentMethod.value || selectedPaymentMethod.value
			)
			setPayloadValue(
				'device_session_id',
				window.OpenPay.deviceData.setup('formId')
			)
			setPayloadValue('previousRequest', route.query.previousRequest as string)
			// Marca «Con reserva» la búsqueda de la que salió esta tarifa.
			setPayloadValue('hotelSearchId', route.query.hotelSearchId as string)
			setPayloadValue(
				'companyBranchId',
				Number(route.query.companyBranchId) || undefined
			)

			if (selectedPaymentMethod.value === 'destination') {
				setPayloadValue('guaranteeCardId', Number(selectedCardId.value) || null)
			}

			setPayloadValue(
				'redirectUrl',
				import.meta.env.VITE_PUBLIC_BASE_URL + '/services/hotel/confirmation'
			)

			try {
				const withWarnings = Boolean(policyInformation.value?.warnings?.length)
				await createBooking()

				if (paymentMethod.value === 'credit' && !withWarnings) {
					router.push({ name: 'hotel.confirmation' })
					toast.success('Su reservación se ha creado con éxito.')
				} else if (paymentMethod.value === 'credit' && withWarnings) {
					router.push({ name: 'dashboard' })
					toast.warning(
						'Su reservación se ha solicitado con éxito y ahora se encuentra en espera de aprobación.'
					)
				} else if (paymentMethod.value === 'card') {
					router.push({ name: 'hotel.confirmation' })
					toast.success('Su reservación se ha creado con éxito.')
				} else if (selectedPaymentMethod.value === 'destination') {
					router.push({ name: 'hotel.confirmation' })
					toast.success(
						'Su reservación se ha creado con éxito y el pago se realizará en el hotel.'
					)
				}
			} catch (err: any) {
				if (err?.response?.status == 402) {
					const { setHotelConfirmations, setStatusMessage } = useConfirmations()
					setHotelConfirmations(
						err?.response?.data?.requests,
						false,
						err?.response?.data?.message,
						err?.response?.data?.paymentInfo
					)
					setStatusMessage(err?.response?.data?.message)
					sessionStorage.setItem(
						'hotelBookingResult',
						JSON.stringify({
							requests: err?.response?.data?.requests,
							message: err?.response?.data?.message,
							paymentInfo: err?.response?.data?.paymentInfo,
						})
					)
					router.push({ name: 'hotel.confirmation' })
				} else if (err?.response?.status == 408) {
					setError(err?.response?.data?.message)
					router?.back()
				}
				// Los demás errores ya se muestran en la alerta de useHotelBook.
			}
		} else {
			toast.error('Se encontraron campos inválidos o vacíos')
		}
	}, 500)

	const loadingMessage = computed(() => {
		if (creatingBooking.value && paymentMethod.value === 'credit') {
			return 'Creando reservación...'
		}

		if (creatingBooking.value && paymentMethod.value === 'card') {
			return 'Realizando pago...'
		}

		if (
			creatingBooking.value &&
			selectedPaymentMethod.value === 'destination'
		) {
			return 'Creando reservación...'
		}

		return 'Cargando...'
	})

	watch(users, async (value) => {
		if (value) {
			await companyOpenPayCardsRefetch()
		}
	})

	return {
		form,
		route,
		hotelRate,
		isFetching,
		imgUrl,
		invalidImage,
		guests,
		travelers,
		travelersIds,
		users,
		adicionalCharges,
		chargesGroups,
		allSelected,
		expandedRefs,
		selectedPaymentMethod,
		paymentOptions,
		userCards,
		companyCards,
		travelerCards,
		travelerId,
		selectedCardId,
		memberId,
		selectedBillingInformation,
		companyBillingId,
		requireInvoice,
		invoiceOptions,
		actualBillingInvalid,
		cardType,
		validationErrors,
		validationGroups,
		termsAndConditions,
		formIsFilled,
		loadingMessage,
		disclaimerModalMessage,
		validationHandlers,
		disclaimerHandlers,
		invoiceDisclaimer,
		creatingBooking,
		attemptedToSubmit,
		activeAuthorized,
		inputTypes,
		intToOrdinal,
		isInternal,
		company,
		credit,
		// companyGroup,
		paymentTypes,
		policyInformation,
		policyErrorFlag,
		validate,
		validateTravelers,
		validateAuthorizedGroups,
		validatePaymentMethod,
		validateCostCenter,
		setMandatoryCostCenterRequirement,
		validateBillingInformation,
		selectAllAuthorizedCharges,
		handleSubmit,
		policyObjectMapWithCountryNames,
		policyObjectMap,
		availablePolicies,
		loadingPolicies,
		isLoading,
		actionShowModal,
		showModal,
		travelerEmail,
		cardUserId,
		travelerHasBillingInfo,
		tripReason,
		otherTripReason,
		tripReasonCatalog,
	}
}

export default useHotelRate
